var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zgq-container"},[_vm._l((_vm.itemList),function(item,index){return _c('Block',{key:index,attrs:{"block":item}})}),_c('Scroll',{attrs:{"scrollFlag":_vm.scrollFlag,"isEnd":_vm.isEnd}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }